<template>
    <div class="legend-panel shadow" v-if="legendMax">
        <div class="legend-header" v-show="legend.unit">{{ legend.unit | capitalize }}</div>
        <div :class="rowStyle(i)" v-for="i in legend.labels.length" :key="i">
            <div class="legend-cell" :style="cellStyle(i)"></div> {{ legend.labels[i - 1] }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { scaleLinear } from 'd3-scale'

export default {
  name: 'LegendPanel',
  data: function () {
    return {
      colorScale: null
    }
  },

  computed: {
    ...mapGetters({
      allLegends: 'allLegends',
      legendHover: 'legendHover',
      legendIntervalHover: 'legendIntervalHover',
      legendMin: 'legendMin',
      legendMax: 'legendMax',
      overlayMode: 'overlayMode',
      queryYear: 'queryYear',
      selectedStatistic: 'selectedStatistic'
    }),

    legend: function () {
      if (!this.selectedStatistic) {
        return { breaks: [], labels: [] }
      }
      return this.allLegends[this.selectedStatistic.legend]
    }
  },

  watch: {
    legendMin: function () { this.generateColorScale() },
    legendMax: function () { this.generateColorScale() }
  },

  methods: {
    cellStyle: function (i) {
      if (!this.legendMax) {
        return {}
      }
      if (!this.colorScale) {
        this.generateColorScale()
      }
      let range = this.legendMax - this.legendMin
      let step = range / 10
      return {
        backgroundColor: this.colorScale(this.legendMin + step * i)
      }
    },

    generateColorScale: function () {
      this.colorScale = scaleLinear()
        .domain([this.legendMin, this.legendMax])
        .range(['yellow', 'red'])
    },

    rowStyle: function (i) {
      let hover = false
      // Code style note: I've avoided ternary operator and preferred an
      // if-else tree because it is more readable and maintainable
      if (this.overlayMode === 'k') {
        // Kriging overlay mode
        if (this.legendIntervalHover + 1 === i) {
          hover = true
        }
      } else {
        // Choropleth overlay mode
        if (i === 1 && !this.legendHover) {
          // Data not available: highlight first interval
          hover = true
        } else if (i === 1 && this.legendHover <= this.legend.breaks[0]) {
          // Below first break
          hover = true
        } else if (i === this.legend.breaks.length + 1 && this.legendHover > this.legend.breaks[this.legend.breaks.length - 1]) {
          // Above last break
          hover = true
        } else if (this.legendHover > this.legend.breaks[i - 2] && this.legendHover <= this.legend.breaks[i - 1]) {
          hover = true
        }
      }
      return 'legend-row' + (hover ? ' hover' : '')
    }
  }
}
</script>

<style scoped>
    .legend-panel {
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 100;
        background-color: white;
        transition: background-color .5s;
    }
    .legend-header {
        border-bottom: 1px solid #eaeaea;
        text-align: center;
        padding: 4px 6px;
    }
    .legend-row {
        padding: 2px 6px;
    }
    .legend-cell {
        display: inline-block;
        height: 1.4ex;
        width: 1em;
        margin-right: 1px;
    }
    .legend-row.hover {
        background: #92c1b5;
        transition: background-color .5s;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/LegendPanel.vue